import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MenuInputWithTitle from '../components/MenuInputWithTitle';
import messages from './messages';

const AvgAmountOfAid = ({ onChange, initialValue }) => {
  const grant = get(initialValue, 'grant.value', '') || '';
  const pellGrant = get(initialValue, 'pellGrant.value', '') || '';
  const studentLoan = get(initialValue, 'studentLoan.value', '') || '';
  return (
    <React.Fragment>
      <MenuInputWithTitle
        inputId="percentage-receiving-aid-grant"
        title={messages.grant}
        value={grant}
        type="number"
        min="0"
        max="100"
        onChange={(e) => {
          onChange(e, {
            grant: { ...initialValue.grant, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.grant.showError}
      />
      <MenuInputWithTitle
        inputId="percentage-receiving-aid-pellgrant"
        title={messages.pellGrant}
        value={pellGrant}
        type="number"
        min="0"
        max="100"
        onChange={(e) => {
          onChange(e, {
            pellGrant: { ...initialValue.pellGrant, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.pellGrant.showError}
      />
      <MenuInputWithTitle
        inputId="percentage-receiving-aid-loan"
        title={messages.studentLoan}
        value={studentLoan}
        type="number"
        min="0"
        max="100"
        onChange={(e) => {
          onChange(e, {
            studentLoan: { ...initialValue.studentLoan, value: e.target.value },
          });
        }}
        isErrorVisible={initialValue.studentLoan.showError}
      />
    </React.Fragment>
  );
};

AvgAmountOfAid.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default AvgAmountOfAid;
